import React from 'react';
import useMediaQuery from '../useMediaQuery'; 

const Footer = () => {
  const isMobile = useMediaQuery(768 * 2);

  const footerStyle = {
    backgroundColor: '#0a0a0a',
    borderTop: '1px solid #1a1a1a',
    color: '#666666',
    fontSize: isMobile ? '0.85rem' : '1rem',
    textAlign: 'center',
    padding: isMobile ? '20px 0' : '32px 0',
    left: 0,
    width: '100vw',
    bottom: 0,
    fontFamily: "'Inter', sans-serif",
    fontWeight: '500',
  };

  return (
    <footer style={footerStyle}>
      Powered by the Vector Vault Cloud
    </footer>
  );
};

export default Footer;
